// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

export interface CreateFavoriteRequestPayload {
  onlineCourseId?: number;
  labId?: number;
  success: Function;
}
export interface CreateFavoriteSuccessPayload {}

export interface CreateFavoriteFailPayload {
  error: Error;
}

export const createFavoritesActions = createAsyncAction(
  'elearning/CREATE_FAVORITE',
  'elearning/CREATE_FAVORITE_SUCCESS',
  'elearning/CREATE_FAVORITE_FAIL'
)<
  CreateFavoriteRequestPayload,
  CreateFavoriteSuccessPayload,
  CreateFavoriteFailPayload
>();
